import React from "react";
import {useSelector} from "react-redux";
import {TokenState} from "../../state/tokenSlice";
import {useParams} from "react-router-dom";

import PdfViewer from "../components/PdfViewer";
import Suspense from "../components/Suspense";

export default function DiplomaPreview() {
    const {uuid} = useParams()
    const token = useSelector<TokenState, string | undefined>(state => state.token)
    if (typeof token === 'undefined') {
        return <Suspense/>
    } else {
        return (
            <PdfViewer uuid={uuid} token={token}/>
        )
    }
}